<app-header class="full-width"></app-header>
<main id="content" class="js-content" role="main">
<div class="grid-row">
  <div class="column-two-thirds">
    <h1 class="heading-xlarge">The multiplication tables check service is currently closed.</h1>
    <p>The multiplication tables check service will open for schools to prepare for the June 2022 statutory check on Monday 21 March 2022.</p>
    <p>Further guidance on the check is available in the <a href="https://www.gov.uk/government/publications/2022-key-stage-2-assessment-and-reporting-arrangements-ara">2022 assessment and reporting arrangements</a>.</p>
  </div>
</div>
</main>
<app-footer></app-footer>
